import { useEffect, useState } from 'react'
import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Pagination, Typography } from '@mui/material';
import DocumentAuthenticationFilterComponent from '../authentication-filters/document-authentication-filter.component';
import useAuthentication from '../../../hooks/useAuthentication';
import AuthenticationListSkeletonComponent from '../../skeletons/authentication-list-skeleton.component';
import moment from "moment";
import DocumentAuthenticationViewDialog from "../dialog/document-authentication-view.dialog";


const DocumemtAuthenticationTableHeader = () => {

    const tablecell = [
        { label: 'Document ID' },
        { label: 'Document Type' },
        { label: 'Issued By' },
        { label: 'Authentication Status' },
        // { label: 'Image URL' },
        { label: 'Ovcode Reference' },
        { label: 'Timestamp' }

    ]

    return (
        <TableHead >
            <TableRow>
                {tablecell.map((value, index) => {
                    return (
                        <TableCell sx={{ fontWeight: 700, color: '#3333CFCE', backgroundColor: "#D8D8FD", borderTop: "1px solid #7A78F7",
                            borderBottom: "1px solid #7A78F7", borderLeft: (index === 0) ? "1px solid #7A78F7" : {}, borderTopLeftRadius: (index === 0) ? "8px" : {},
                            borderRight: (index === 5) ? "1px solid #7A78F7" : {}, borderTopRightRadius: (index === 5) ? "2px" : {}, }}>{value.label}</TableCell>

                    )
                })}
            </TableRow>
        </TableHead>
    )
}


const DocumentAuthenticationTable = (props) => {

    const {data, setOpenDocumentView, setDocumentId, index} = props;

    const handleOpenDetailView = (e, id) => {
        setOpenDocumentView(true);
        setDocumentId(id);
    }

    return(
        <TableRow key={index} sx={{cursor: "pointer", '&:last-child td, &:last-child th': {border: 0}, '& td, & th': {borderBottom: 0}}} onClick={(e) => handleOpenDetailView(e, data?.id)}>
            <TableCell component="th" scope="row">{data?.document_id}</TableCell>
            <TableCell component="th" scope="row">{data?.document_type}</TableCell>
            <TableCell component="th" scope="row">{data?.issued_by}</TableCell>
            <TableCell component="th" scope="row" sx={{color: data?.authentication_status === "Completed" || data?.authentication_status === "Success" ? '#40BF7E' : data?.authentication_status === "Pending" ?  "#FFA500" : '#E87867' }}>
                {data?.authentication_status}
            </TableCell>
            <TableCell component="th" scope="row">{data?.ovcode_reference}</TableCell>
            <TableCell component="th" scope="row">{moment(data?.created_time).format("MMMM DD, YYYY h:mm:ss A")}</TableCell>
        </TableRow>

    )
}


const DocumentAuthenticationComponent = () => {

    const {authenticationDocumentList, isFetchingAuthenticationDocumentList, pagination, getDocumentAuthenticationLogs} = useAuthentication();

    const [page, setPage] = useState(1);
    const [type, setType] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    
    const [documentId, setDocumentId] = useState(null);
    const [openDocumentView, setOpenDocumentView] = useState(false);
    

    useEffect(() => {   
        const limit = 10;

        if (selectedStatus && !type) {
            let parameters = {
                status: selectedStatus?.value,
                page: page,
                limit: limit,
            }

            getDocumentAuthenticationLogs(parameters);

        } else if (type && !selectedStatus) {
            let parameters = {
                type: type,
                page: page,
                limit: limit,
            }

            getDocumentAuthenticationLogs(parameters);

        } else if (type && selectedStatus) {
            let parameters = {
                status: selectedStatus?.value,
                type: type,
                page: page,
                limit: limit,
            }

            getDocumentAuthenticationLogs(parameters);

        } else {
            let parameters = {
                page: page,
                limit: limit,
            }

            getDocumentAuthenticationLogs(parameters);
        }
    }, [selectedStatus, type, page])
    

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            // update productName with the current input value
            const name = event.target.value;
            setType(name);
        } else if (event.key === 'Backspace') {
            // wait for the DOM to update
            setTimeout(() => {
                const name = event.target.value;
                console.log("name after backspace", name);
                if (name === "") {
                    setType("");
                }
            }, 0);
        }
    }

    const handleSelectStatusFilter = (selectedOption) => {
        if (!selectedOption) {
            setSelectedStatus("");

        } else {
            setSelectedStatus(selectedOption);
        }
    }

    console.log("authenticationDocumentList aaa", authenticationDocumentList)


    return (
        <Box>
            <Grid item xs={12} sx={{mb: 2, mt: 1.5}}>
                <Grid container spacing={2} sx={{ justifyContent: "flex-end", alignItems: "center" }}>
                    <Grid item xs={12} sm={12}>
                        <DocumentAuthenticationFilterComponent 
                            selectedStatus={selectedStatus} 
                            type={type}
                            handleSelectStatusFilter={handleSelectStatusFilter}
                            handleKeyDown={handleKeyDown}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <TableContainer component={Paper} sx={{  borderRadius: 2, width: "100%", mt: 1 }}>
                <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650, width: '100% !important', tableLayout: "fixed !important" }}>
                    <DocumemtAuthenticationTableHeader />
                    { isFetchingAuthenticationDocumentList ?
                        <TableBody>
                            <AuthenticationListSkeletonComponent name={'Document'} />
                        </TableBody>
                    :
                        <TableBody>
                            {((authenticationDocumentList && authenticationDocumentList?.length > 0) ?
                                authenticationDocumentList?.map((data, index) => (
                                    <DocumentAuthenticationTable data={data} index={index} setOpenDocumentView={setOpenDocumentView} setDocumentId={setDocumentId} />
                                )) 
                            :
                                <TableRow sx={{'&:last-child td, &:last-child th': {border: 0}, '& td, & th': {borderBottom: 0}}}>
                                    <TableCell colSpan={6} align="center">
                                        <Typography sx={{fontSize: 16, color: "#58565f", padding: "40px 40px 20px 40px"}}>
                                            No available data to display
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    }
                </Table>
                {!isFetchingAuthenticationDocumentList && authenticationDocumentList?.length !== 0 &&
                    <Pagination
                        count={pagination}
                        page={page}
                        // onChange={}
                        style={{ margin: "auto", width: "fit-content", paddingTop: 30, paddingBottom: 30 }}
                    />
                }
            </TableContainer>

            {openDocumentView &&
                <DocumentAuthenticationViewDialog 
                    openDocumentView={openDocumentView} 
                    setOpenDocumentView={setOpenDocumentView} 
                    documentId={documentId}
                />
            }
        </Box>
    );
}

export default DocumentAuthenticationComponent
